import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { textStyles } from "../../../shared/textStyles";

const contentsBaseStyles = css`
  align-items: center;
  border-radius: 999rem;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: ${tombac.space(0, 2)};
  transition: background-color 0.1s ease-out;
  white-space: nowrap;
`;

const contentsActiveBaseStyles = css`
  font-family: ${tombac.altFontFamily};
  font-weight: 600;
`;

export const ActiveItemContentPlaceholder = styled.span`
  ${contentsBaseStyles}
  ${contentsActiveBaseStyles}
  opacity: 0;
  user-select: none;
`;

export const ItemContent = styled.span<{
  isDisabled: boolean;
  isHovered: boolean;
  isInvalid: boolean;
  isPressed: boolean;
  isSelected: boolean;
}>`
  ${contentsBaseStyles}

  ${({
    isDisabled,
    isHovered,
    isInvalid,
    isPressed,
    isSelected,
    theme: {
      components: {
        toggleGroup: { current: { item } = {} },
      },
    },
  }) => [
    css`
      background-color: ${tombac.parse(item!.backgroundColor)};
      color: ${tombac.parse(item!.color)};
    `,
    isDisabled &&
      css`
        color: ${tombac.parse(item!.disabled!.color)};
      `,
    isSelected
      ? css`
          ${contentsActiveBaseStyles}

          ${isDisabled
            ? css`
                background-color: ${tombac.parse(
                  item!.disabled!.checked?.backgroundColor
                )};
                color: ${tombac.parse(item!.disabled!.checked?.color)};
              `
            : css`
                background-color: ${tombac.parse(
                  item!.checked!.backgroundColor
                )};
                color: ${tombac.parse(item!.checked!.color)};

                ${isInvalid &&
                css`
                  background-color: ${tombac.parse(
                    item!.invalid!.checked?.backgroundColor
                  )};
                  color: ${tombac.parse(item!.invalid!.checked?.color)};
                `}
              `}
        `
      : !isDisabled &&
        (isPressed
          ? css`
              background-color: ${tombac.parse(item!.pressed!.backgroundColor)};
              color: ${tombac.parse(item!.pressed!.color)};
            `
          : isHovered &&
            css`
              background-color: ${tombac.parse(item!.hover!.backgroundColor)};
              color: ${tombac.parse(item!.hover!.color)};
            `),
  ]}

  ${propStyling}
  ${textStyles}
`;
